import { z } from "zod";

// Campos do lead de demo, compartilhados pelo modal "Agende sua demo" e pelo
// form da LP de régua: os dois vão para o mesmo /api/lead.

export const STORES_OPTIONS = [
  { value: "1", label: "1 loja" },
  { value: "2-5", label: "2 a 5 lojas" },
  { value: "6-10", label: "6 a 10 lojas" },
  { value: "11-20", label: "11 a 20 lojas" },
  { value: "20+", label: "Mais de 20 lojas" },
];

export const demoLeadSchema = z.object({
  name: z.string().min(2, "Informe seu nome"),
  phone: z
    .string()
    .min(1, "Informe seu WhatsApp")
    .min(14, "Telefone inválido")
    .max(15, "Telefone inválido"),
  company: z.string().min(2, "Informe o nome da rede"),
  storesRange: z.enum(["1", "2-5", "6-10", "11-20", "20+"], {
    message: "Selecione a quantidade de lojas",
  }),
  honeypot: z.string().optional(),
});

export type DemoLeadValues = z.infer<typeof demoLeadSchema>;

export const EMPTY_DEMO_LEAD: DemoLeadValues = {
  name: "",
  phone: "",
  company: "",
  storesRange: undefined as unknown as DemoLeadValues["storesRange"],
  honeypot: "",
};
